// @flow
import * as React from 'react';
import { useState } from 'react';
import { Button, ButtonProps, Menu, MenuItem } from '@mui/material';
import { MaEnrollmentFormDialog } from './ma-enrollment-form';
import { useConfirm } from '@coverright/features';
import { theme } from '../../../../../app/theme';
import { useClient } from '../../../hooks/client-context';
import { getAgeByBirthdate } from '@coverright/utils';
import { MgEnrollmentFormDialog } from './mg-enrollment-form';
import { PdpEnrollmentFormDialog } from './pdp-enrollment-form';
import { EnrollmentListItemOutput, EnrollmentType, Gender } from '@coverright/data-access/types/enrollment';
import moment from 'moment';
import { useAgent } from '../../../../../shared';

export const CreateEnrollmentButton = (props: ButtonProps & {onSubmit: () => void}) => {
  const client = useClient();
  const agent = useAgent();
  const {onSubmit, ...rest} = props;
  const [open, setOpen] = useState(false);
  const [type, setType] = useState<EnrollmentType>();
  const [enrollment, setEnrollment] = useState<Partial<EnrollmentListItemOutput>>();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleMenuSelect = (value: EnrollmentType) => {
    setType(value)
    setAnchorEl(null);
    setEnrollment({
      zip: client.zip,
      county: client.countyName,
      email: client.email || undefined,
      firstName: client.firstName,
      lastName: client.lastName,
      birthDate: client.birthDate,
      phoneNumber: client.phoneNumber,
      tobacco: client.tobacco,
      gender: client.gender as Gender || undefined,
      age: client.birthDate ? getAgeByBirthdate(client.birthDate) : undefined,
      applicationDate: moment().format('YYYY-MM-DD'),
      agentId: agent?.id
    })
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    setType(undefined);
    setAnchorEl(null);
    setEnrollment(undefined);
  }

  return <>
    <MaEnrollmentFormDialog enrollment={enrollment}
                            onSubmit={refresh => {
                              onClose()
                              refresh && onSubmit()
                            }}
                            open={type === EnrollmentType.Ma && open}
                            onClose={onClose} />
    <MgEnrollmentFormDialog enrollment={enrollment}
                            onSubmit={refresh => {
                              onClose()
                              refresh && onSubmit()
                            }}
                            open={type === EnrollmentType.Mg && open}
                            onClose={onClose} />
    <PdpEnrollmentFormDialog enrollment={enrollment}
                            onSubmit={refresh => {
                              onClose()
                              refresh && onSubmit()
                            }}
                            open={type === EnrollmentType.Pdp && open}
                            onClose={onClose} />
    <Button variant={'outlined'} size={'small'}
            sx={{alignSelf: 'flex-start'}}
            onClick={e => setAnchorEl(e.currentTarget)}
            {...rest}>
      {props.children}
    </Button>
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
    >
      <MenuItem onClick={() => handleMenuSelect(EnrollmentType.Ma)}>Medicare Advantage</MenuItem>
      <MenuItem onClick={() => handleMenuSelect(EnrollmentType.Mg)}>Medicare Supplement</MenuItem>
      <MenuItem onClick={() => handleMenuSelect(EnrollmentType.Pdp)}>Prescription Drug</MenuItem>
    </Menu>
  </>;
};
